/**
 *
 * InvalidPasswordModal
 *
 */

import React from 'react';
import {
  Wrapper,
  PasswordNeeds,
} from './styledComponents';
import PasswordNeed from './PasswordNeed';

import Modal from 'components/Modal';
import PasswordProblemSVG from 'components/Icon/PasswordProblemSVG';
import H1 from 'components/H1';

const InvalidPasswordModal = ({ close, modalProps }) => (
  <Modal shakeOnOpen close={close} title='Password Requirements Not Met'>
    <Wrapper>
      <PasswordProblemSVG />
      <H1>
        Gotta be stronger.
      </H1>
      <PasswordNeeds>
        This password can be easily guessed. Please try something else.
      </PasswordNeeds>
    </Wrapper>
  </Modal>
);

export default InvalidPasswordModal;



// WEBPACK FOOTER //
// ./src/components/InvalidPasswordModal/index.js